<template>
  <div id="SectionManufacturingPricing">
    <UIContainer class="SectionManufacturingPricing__container">
      <div class="SectionManufacturingPricing__content">
        <SectionTitle>
          <template #heading>Investment based on Company size</template>
          <template #title>Pricing plans that scale</template>
          <template #description>
            Have a buyer deadline or reassessment date approaching? Book a
            20-minute scoping call—leave with a timeline, an input checklist,
            and a fixed-price proposal.
          </template>
        </SectionTitle>

        <UIButton s1ize="xl" theme="primary" :to="{ name: 'Contact' }">
          Book a call
        </UIButton>
      </div>

      <div class="SectionManufacturingPricing__plans">
        <PricingPlan v-for="plan in plans" :key="plan.title" v-bind="plan" />
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import PricingPlan, { IPlan } from '@/views/components/misc/PricingPlan.vue'
import UIButton from '@/views/components/ui/buttons/UIButton.vue'

const plans: IPlan[] = [
  {
    title: '15 day free trial',
    // price: '',
    // priceSmall: '€2,000 / $2,400',
    // subtitle: 'per plant',
    features: [
      'Complete carbon footprint analysis',
      'Real-time emissions monitoring',
      'CBAM compliance reporting',
      'Dedicated implementation support',
    ],
    ctaText: 'Start assessment',
    ctaTheme: 'primary',
    ctaStyle: 'filled',
  },
  {
    title: '',
    price: 'Need a Multi-Site Solution?',
    features: [
      'Pilot program available for multi-site implementations',
      'Integration support for existing manufacturing systems',
      'Real-time emissions monitoring',
      'CBAM compliance reporting',
      'Dedicated implementation support',
    ],
    ctaText: 'Get a quote',
    ctaTheme: 'primary',
    ctaStyle: 'filled',
  },
]
</script>

<style lang="scss" scoped>
#SectionManufacturingPricing {
  .SectionManufacturingPricing__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;

    @include md {
      gap: 4rem;
      grid-template-columns: 440px 1fr;
    }
  }

  .SectionManufacturingPricing__content {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @include md {
      gap: 1.25rem;
    }
  }

  .SectionManufacturingPricing__plans {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @include md {
      gap: 2rem;
      flex-direction: row;
    }
  }
}
</style>
